import{main$}from'@shopgate/pwa-common/streams/main';import{SUCCESS_CHECKOUT}from"../constants";/**
 * Gets triggered when the checkout has been completed.
 * @type {Observable}
 */export var checkoutSucceeded$=main$.filter(function(_ref){var action=_ref.action;return action.type===SUCCESS_CHECKOUT;});